import { defaultAppendQueryParamsFn, IrisFilterAppendQueryParamsFn } from './append-filter-query-params-fn';

export function appendPureValueQueryParams(fieldNames: string | string[]): IrisFilterAppendQueryParamsFn {
  return defaultAppendQueryParamsFn<unknown | unknown[]>(
    fieldNames,
    values => Array.isArray(values) ? values : [values],
  );
}
